"use client";

import { ArrowDownWideNarrow, Clock } from "lucide-react";
import { cn } from "@/lib/utils";

export type ShowcaseSort = "newest" | "liked";

export function ShowcaseFilters({
  sort,
  onSortChange,
}: {
  sort: ShowcaseSort;
  onSortChange: (value: ShowcaseSort) => void;
}) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-3">
      {/* Sort */}
      <div className="inline-flex items-center gap-1 rounded-full border border-border/70 bg-card/60 p-1">
        <SortButton active={sort === "newest"} onClick={() => onSortChange("newest")}>
          <Clock className="h-3.5 w-3.5" />
          Newest
        </SortButton>
        <SortButton active={sort === "liked"} onClick={() => onSortChange("liked")}>
          <ArrowDownWideNarrow className="h-3.5 w-3.5" />
          Most liked
        </SortButton>
      </div>
    </div>
  );
}

function SortButton({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-medium transition",
        active ? "bg-foreground text-background" : "text-muted-foreground hover:text-foreground",
      )}
    >
      {children}
    </button>
  );
}
